<template>
  <div class="iphone-activity-item4">
    <h2 class="iphone-activity-title">产品优势</h2>
    <ul class="iphone-activity-item4-ul">
      <li v-for="(item, index) in childItem.propsValue.data" :key="index">
        <h3>
          <span class="iphone-activity-item4-number">{{
            item.customField1
          }}</span>
          <span class="iphone-activity-item4-number cont-sub"
            >&nbsp;{{ item.customField2 }}</span
          >
        </h3>
        <p class="iphone-activity-item4-desc">{{ item.customField3 }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
// 量化数据-移动端
export default {
  name: "MkLianghuashujuPhone",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "数值",
          type: "text",
        },
        {
          code: "customField2",
          label: "单位",
          type: "text",
        },
        {
          code: "customField3",
          label: "描述",
          type: "text",
        },
      ],
      data: [
        {
          customField1: "5000",
          customField2: "+",
          customField3: "央、国企等大型集团企业用户",
        },
        {
          customField1: "30",
          customField2: "秒",
          customField3: "平均单据审核时长",
        },
        {
          customField1: "1",
          customField2: "天",
          customField3: "平均报销周期",
        },
        {
          customField1: "95",
          customField2: "%",
          customField3: "手工填写量减少",
        },
      ],
      max: 6,
      min: 4,
    };
  },
};
</script>

<style scoped lang="scss">
.iphone-activity-item4 {
  width: 100%;
  height: 100%;
  padding: 18px 18px 56px;
  background: url(https://mk.yybip.com/group1/M00/00/C1/CgoRDGLPw3OAALfzAAAlTpWYG0E71.jpeg)
    no-repeat bottom left;
  background-size: 100%;
  .iphone-activity-title {
    text-align: center;
    color: #e31924;
    line-height: 2;
    font-size: 20px;
    font-weight: bold;
  }
  .iphone-activity-item4-ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      width: 50%;
      text-align: center;
      margin-top: 18px;
    }
  }
  .iphone-activity-item4-number {
    font-size: 28px;
    color: #e31924;
    font-weight: bold;
    position: relative;
  }
  .cont-sub {
    font-size: 14px;
  }
  .iphone-activity-item4-desc {
    font-size: 12px;
    color: #6c6c6c;
  }
}
</style>
